class SportwristxProductFinder extends HTMLElement {
  connectedCallback() {
    this.answers = [...this.querySelectorAll('[data-next-step]')];
    this.intro = this.querySelector('[data-finder-intro]');
    this.status = this.querySelector('[data-finder-status]');
    this.controls = this.querySelector('[data-finder-controls]');
    this.startButton = this.querySelector('[data-finder-start]');
    this.backButton = this.querySelector('[data-finder-back]');
    this.continueButton = this.querySelector('[data-finder-continue]');
    this.history = [];
    this.selectedAnswer = null;

    this.answers.forEach((answer) => answer.addEventListener('click', (event) => this.select(event)));
    this.startButton?.addEventListener('click', () => this.start());
    this.backButton?.addEventListener('click', () => this.back());
    this.continueButton?.addEventListener('click', () => this.continueSelection());
    this.querySelector('[data-finder-reset]')?.addEventListener('click', () => this.reset());
    this.showIntro(false);
  }

  start() {
    const firstPanel = this.querySelector('[data-finder-step]');
    if (!firstPanel) return;
    this.history = [Number(firstPanel.dataset.finderStep)];
    this.intro.hidden = true;
    this.controls.hidden = false;
    this.status.hidden = false;
    this.showStep(this.history[0]);
  }

  select(event) {
    const answer = event.currentTarget;
    const panel = answer.closest('[data-finder-step]');
    panel?.querySelectorAll('[data-next-step]').forEach((item) => {
      const selected = item === answer;
      item.setAttribute('aria-current', String(selected));
      item.setAttribute('aria-checked', String(selected));
    });
    this.selectedAnswer = answer;
    this.continueButton?.removeAttribute('disabled');
  }

  continueSelection() {
    if (!this.selectedAnswer) return;
    const nextStep = Number(this.selectedAnswer.dataset.nextStep);
    if (nextStep > 0) {
      this.history.push(nextStep);
      this.showStep(nextStep);
      return;
    }
    if (this.selectedAnswer.dataset.destination) {
      window.location.assign(this.selectedAnswer.dataset.destination);
      return;
    }
    if (this.status) {
      this.status.textContent = 'Recommendation unavailable. Choose another option.';
      this.status.hidden = false;
    }
  }

  showStep(step, focus = true, animate = true) {
    this.selectedAnswer = null;
    this.continueButton?.setAttribute('disabled', '');
    this.querySelectorAll('[data-finder-step]').forEach((panel) => {
      const active = Number(panel.dataset.finderStep) === step;
      panel.hidden = !active;
      panel.inert = !active;
      panel.classList.toggle('is-entering', active && animate);
      panel.querySelectorAll('[data-next-step]').forEach((answer) => {
        answer.setAttribute('aria-current', 'false');
        answer.setAttribute('aria-checked', 'false');
      });
      if (active && animate) requestAnimationFrame(() => requestAnimationFrame(() => panel.classList.remove('is-entering')));
    });
    if (animate) this.animateControls();
    if (this.status) {
      this.status.textContent = `Question ${step} of 3`;
      this.status.hidden = false;
    }
    this.backButton?.toggleAttribute('disabled', this.history.length <= 1);
    if (focus) this.querySelector(`[data-finder-step="${step}"] button`)?.focus();
  }

  animateControls() {
    if (!this.controls || this.controls.hidden) return;
    this.controls.classList.add('is-entering');
    requestAnimationFrame(() => requestAnimationFrame(() => this.controls.classList.remove('is-entering')));
  }

  showIntro(focus = true) {
    this.history = [];
    this.selectedAnswer = null;
    this.intro.hidden = false;
    this.controls.hidden = true;
    this.status.hidden = true;
    this.querySelectorAll('[data-finder-step]').forEach((panel) => {
      panel.hidden = true;
      panel.inert = true;
      panel.classList.remove('is-entering');
      panel.querySelectorAll('[data-next-step]').forEach((answer) => {
        answer.setAttribute('aria-current', 'false');
        answer.setAttribute('aria-checked', 'false');
      });
    });
    this.continueButton?.setAttribute('disabled', '');
    if (focus) this.startButton?.focus();
  }

  back() {
    if (this.history.length <= 1) return;
    this.history.pop();
    this.showStep(this.history.at(-1));
  }

  reset() {
    this.showIntro();
  }
}

if (!customElements.get('sportwristx-product-finder')) {
  customElements.define('sportwristx-product-finder', SportwristxProductFinder);
}
